import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class WfUserLineQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_file?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
}

export class WfUserLineCriteriaModelQuery {
  query = '';

  constructor(wfUserLineCriteriaModel: WfUserLineQueryCriteriaClass) {

    if (!wfUserLineCriteriaModel) {
      return;
    }

    this.query += wfUserLineCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.value_file.filter(x => x !== '').map(x => '&value_file=' + x).orElse('');
    this.query += wfUserLineCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += '&status=' + wfUserLineCriteriaModel.status;
    this.query += '&orderBy=' + wfUserLineCriteriaModel.orderBy;
    this.query += '&order=' + wfUserLineCriteriaModel.order;
    this.query += '&offset=' + wfUserLineCriteriaModel.offset + '&limit=' + wfUserLineCriteriaModel.limit;
  }
}
